import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-pills',
  templateUrl: './nav-pills.component.html',
  styleUrls: ['./nav-pills.component.scss']
})
export class NavPillsComponent {

}
